/**
 * Normalize public FAQ API payload for UI components.
 * @param {{ landing?: Array, categories?: Array } | null | undefined} data
 */
export function mapPublicFaqsPayload(data) {
  if (!data) {
    return { landingFaqs: [], faqCategories: [] };
  }

  const landingFaqs = Array.isArray(data.landing)
    ? data.landing.map((item) => ({
        id: item.id,
        question: item.question,
        answer: item.answer,
      }))
    : [];

  const faqCategories = Array.isArray(data.categories)
    ? data.categories.map((cat) => ({
        title: cat.title,
        items: Array.isArray(cat.items)
          ? cat.items.map((item) => ({
              id: item.id,
              question: item.question,
              answer: item.answer,
            }))
          : [],
      }))
    : [];

  return { landingFaqs, faqCategories };
}
